import { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

interface ToastProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
  duration?: number;
}

export function Toast({ type, message, onClose, duration = 4000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const isSuccess = type === 'success';

  return (
    <div
      style={{
        position: 'fixed',
        top: '2rem',
        right: '2rem',
        zIndex: 9999,
        minWidth: '320px',
        maxWidth: '500px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,48,60,0.15)',
        border: `2px solid ${isSuccess ? '#10b981' : '#ef4444'}`,
        padding: '1rem 1.25rem',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.75rem',
        animation: 'slideIn 0.3s ease-out',
      }}
    >
      {/* Icône */}
      <div
        style={{
          flexShrink: 0,
          width: '24px',
          height: '24px',
          color: isSuccess ? '#10b981' : '#ef4444',
        }}
      >
        {isSuccess ? <CheckCircle size={24} /> : <XCircle size={24} />}
      </div>

      {/* Message */}
      <div style={{ flex: 1, paddingTop: '2px' }}>
        <p
          style={{
            margin: 0,
            fontSize: '0.95rem',
            fontWeight: 500,
            color: '#00303c',
            lineHeight: '1.4',
          }}
        >
          {message}
        </p>
      </div>

      {/* Bouton fermer */}
      <button
        onClick={onClose}
        style={{
          flexShrink: 0,
          background: 'transparent',
          border: 'none',
          padding: '0.25rem',
          cursor: 'pointer',
          color: '#999',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '6px',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f3f4f6';
          e.currentTarget.style.color = '#00303c';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#999';
        }}
      >
        <X size={18} />
      </button>

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
